export const BADGE_VARIANT = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  default: 'default',
};
export const badgeVariants = Object.keys(BADGE_VARIANT);
